/**
 * Prefill "idea" cards shown beneath the landing-screen composer. Clicking a card
 * drops its `prompt` into the input (it does not auto-send) so a first-time user
 * sees their words land in the box and can edit before sending.
 *
 * Prompts deliberately model good canvas-agent first messages.
 */

import {
  FileText,
  Lightbulb,
  Mail,
  Sparkles,
  type LucideIcon,
} from "lucide-react";

export interface CanvasComposerSuggestion {
  id: string;
  label: string;
  /** One-line hint shown under the label. */
  hint: string;
  /** Text dropped into the composer when the card is clicked. */
  prompt: string;
  icon: LucideIcon;
}

export const CANVAS_COMPOSER_SUGGESTIONS: CanvasComposerSuggestion[] = [
  {
    id: "brainstorm",
    label: "Brainstorm ideas",
    hint: "Spin up a wall of possibilities",
    prompt:
      "Give me 5 creative ideas as text notes. Use markdown and color them creatively to make them visually engaging.",
    icon: Lightbulb,
  },
  {
    id: "outline",
    label: "Draft an outline",
    hint: "Structure a project or doc",
    prompt: "Create a project outline document for a new initiative.",
    icon: FileText,
  },
  {
    id: "emails",
    label: "Pull in my emails",
    hint: "Bring recent context onto the canvas",
    prompt: "Add my last 10 emails to the canvas.",
    icon: Mail,
  },
  {
    id: "capabilities",
    label: "Show me what's possible",
    hint: "See what this canvas can do",
    prompt: "What are all the things you can help me with on this canvas?",
    icon: Sparkles,
  },
];
